import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';
 
class FeaturedHome extends React.Component{

   constructor(props){
           super(props);
   
           
           this.state = {
               
               loading : 1,
               services:this.props.services, 
               content:this.props.content, 
               
           }
           
   
       }
        
       componentDidMount()
       {  
           if(this.props.services && this.state.loading === 1)
           {
                this.setState({loading:0});     
           }
   
           const script = document.createElement("script");
           script.src   = base_url+"assets/js/loadSlider.js";  
           script.async = true;
           document.body.appendChild(script);
   
           script.onload = () => {
           if (window.loadSlider && this.props.services.length > 0) {
           window.loadServicesHome();
           this.setState({loading:0})
           }
           };
            
       }
   


    render()
    { 
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
    return (

 
             <div class="section-full bg-white p-t80 p-b40 scale-bg-top scale-bg-bottom">
                <div class="container">
                     
                        <div class="section-head text-center">
                            <h2 class="text-uppercase">{this.state.content[3].title}</h2>
                            <div class="wt-separator-outer">
                                <div class="wt-separator style-square">
                                  <span class="separator-left site-bg-primary"></span>
                                  <span class="separator-right site-bg-primary"></span>
                              </div>
                            </div>
                              <p>Contrive Construction Maintenance Electromechanical
specializes in delivering a wide range of services across
residential projects, multi–storey buildings, pumping
stations, infrastructure construction, and various
industrial sectors, including</p> 
                        </div>
                    	 
                        <div class="section-content">
                            
                            <div class="owl-carousel Home-services-carousel owl-btn-vertical-center">
                            {this.state.services.map((item, index) => (
                                <div class="item">
                                	<div class="wt-box bg-white">
                                        <div class="wt-media">
                                             <img src={item.home_image} alt={item.title} /> 
                                        </div>
                                        <div class="wt-info p-tb30">
                                            <h4 class="wt-title m-t0 m-b5">{item.title} </h4>
                                         </div>
                                    </div>
                                </div>
                            ))}
                               
								
                            </div>
                        
                        </div>
         		</div>
         	</div>
         
       
    );
}

}

export default FeaturedHome;